module.exports = __webpack_public_path__ + "img/pic-succeed.2823d111.png";